'use strict';

define('lib/analytics/blocks/dealer.search.block',[], function () {
  // dealer.dataLayer contained link_text, making it all worthless
  return function dealerSearchBlock(term, type, count, brand) {
    var block = {
      dealer_search_brand: brand || 'Toyota',
      dealer_search_results_count: count || 0,
      dealer_search_term: term,
      dealer_search_type: type,
    };

    if (!count) {
      block.error_field = type;
    }

    return block;
  };
});

